/* ==========================================================================
   CarouselRxjs > Vendor > Config
   ========================================================================== */

const config = {
    init: true,
    slidesPerView: 6,
    slidesPerGroup: 6,
    spaceBetween: 20,
    speed: 900,
    containerModifierClass: 'carousel-rxjs--',
    slideClass: 'carousel-rxjs__slide',
    slideActiveClass: 'carousel-rxjs__slide--active',
    slideVisibleClass: 'carousel-rxjs__slide--visible',
    slideNextClass: 'carousel-rxjs__slide--next',
    slidePrevClass: 'carousel-rxjs__slide--prev',
    wrapperClass: 'carousel-rxjs__wrapper'
};

/* Breakpoints config */
const breakpoints = {
    // when window width is <= 480px
    480: {
        slidesPerView: 1,
        slidesPerGroup: 1
    },
    // when window width is <= 720px
    720: {
        slidesPerView: 2,
        slidesPerGroup: 2
    },
    // when window width is <= 1200px
    1200: {
        slidesPerView: 3,
        slidesPerGroup: 3
    },
    // when window width is <= 1600px
    1600: {
        slidesPerView: 4,
        slidesPerGroup: 4
    }
};

/* Navigation config */
const navigation = id => ({
    nextEl: `.carousel-rxjs__navigation--next.${id}`,
    prevEl: `.carousel-rxjs__navigation--prev.${id}`,
    hiddenClass: 'carousel-rxjs__navigation--hidden',
    disabledClass: 'carousel-rxjs__navigation--disabled'
});

/* Pagination config */
const pagination = id => ({
    el: `.carousel-rxjs__pagination.${id}`,
    modifierClass: 'carousel-rxjs__pagination--',
    currentClass: 'carousel-rxjs__pagination--current',
    totalClass: 'carousel-rxjs__pagination--total',
    hiddenClass: 'carousel-rxjs__pagination--hidden',
    bulletClass: 'carousel-rxjs__bullet',
    bulletActiveClass: 'carousel-rxjs__bullet--active',
    clickable: true,
    clickableClass: 'carousel-rxjs__pagination--clickable'
});

/* Autoplay config */
const autoplay = {
    delay: 7000
};

module.exports = ({ hasBreakpoints, hasNavigation, hasPagination, hasAutoplay, id }) => ({
    ...config,
    breakpoints: hasBreakpoints ? breakpoints : false,
    navigation: hasNavigation ? navigation(id) : false,
    pagination: hasPagination ? pagination(id) : false,
    autoplay: hasAutoplay ? autoplay : false
});
